export default "__VITE_PUBLIC_ASSET__21b5da2a__"